import { config } from '@app/config';
import { useAuthContext } from '@app/core/auth/authentication/context';
import { useImpersonation } from '@app/core/auth/impersonation';
import { useMemo } from 'react';
import { buildVideoEditorProjectUrl } from '../lib/video-editor-project-url';

/**
 * Returns the full URL to open a project in the video editor (new tab), including the JWT from auth context.
 * When an admin is impersonating a user, adds auth_as=userId so the editor knows which user context to use.
 * Returns null if base URL is invalid, projectId is missing, or token is not available.
 */
export function useVideoEditorProjectUrl(projectId: string): string {
  const { token } = useAuthContext();
  const { impersonatedUser } = useImpersonation();

  return useMemo(() => {
    return buildVideoEditorProjectUrl({
      baseUrl: config.videoEditorUrl,
      projectId,
      jwt: token!,
      authAsUserId: impersonatedUser?.id,
    });
  }, [projectId, token, impersonatedUser?.id]);
}
